import { FormCustomFieldRendererParams } from '@/components/Form';

import Conditions, { ConditionsProps } from '../components/Conditions';
import { DEFAULT_GROUP } from '../components/Conditions/consts';

export const renderFilterGroup =
  (props: Omit<ConditionsProps, 'filterGroup' | 'error' | 'onChange'>) =>
  ({ value, onChange, touched, error }: FormCustomFieldRendererParams) => {
    const filterGroup = (value || DEFAULT_GROUP) as ConditionsProps['filterGroup'];
    const showError = Boolean(touched && error);

    return (
      <Conditions error={showError} filterGroup={filterGroup} onChange={onChange} {...props} />
    );
  };
